import type { IconSvgObject } from './types';

const SlashIcon: IconSvgObject = [
  ["path", { d: "M3.99219 20L19.9922 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SlashIcon;
